import { render, staticRenderFns } from "./UniversityCourseDetail.vue?vue&type=template&id=60488db4&"
import script from "./UniversityCourseDetail.vue?vue&type=script&lang=js&"
export * from "./UniversityCourseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports